import { useAtom } from "jotai"
import { undoManagerEnabledState } from "../../../global/state/global"
import ToggleWithDesc from "../../1_atom/toggles/toggleWithDesc"
import { SettingSection } from "./settingSection"

const ExperimentalSettings = () => {
  const [undoManagerEnabled, setUndoManagerEnabled] = useAtom(undoManagerEnabledState)

  return (
    <>
      <SettingSection
        title="Undo / Redo"
        description="Be careful using this with multiple admins."
      >
        <ToggleWithDesc
          label="Enable undo / redo"
          description={`Currently only works on split signup roster editing.`}
          defaultValue={typeof undoManagerEnabled === "boolean" && undoManagerEnabled === true ? true : false}
          callback={(state) => {
            setUndoManagerEnabled(state)
          }}
        />
      </SettingSection>
    </>
  )
}

export default ExperimentalSettings;